import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';
import { TextField } from '@garnish/forms';

export const DeliveryPreferencesFormNotesField = (
  props: DeliveryPreferencesFormNotesFieldProps,
) => {
  const { localNotes, setLocalNotes } = props;
  const { formatMessage } = useIntl();

  return (
    <View style={styles.container}>
      <View style={[styles.row, styles.sectionLabel]}>
        <BodyText sizeMatch={['12']}>
          {formatMessage(messages.deliveryPreferencesNoteLabel)}
        </BodyText>

        <BodyText sizeMatch={['12']} style={localNotes.length === 128 && styles.cautionText}>
          {localNotes.length}/{128}
        </BodyText>
      </View>

      <TextField
        testID="delivery.preferences.notes"
        style={styles.inputField}
        value={localNotes}
        multiline
        maxLength={128}
        placeholder={formatMessage(messages.deliveryPreferencesNotePlaceholder)}
        accessibilityLabel={formatMessage(messages.deliveryPreferencesNoteHint)}
        accessibilityHint={formatMessage(messages.deliveryPreferencesNoteHint)}
        onChangeText={setLocalNotes}
      />
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  deliveryPreferencesNoteLabel: {
    defaultMessage: 'Delivery notes',
    description: 'Delivery | Preferences | Note Label',
  },
  deliveryPreferencesNotePlaceholder: {
    defaultMessage: 'Courier notes, e.g. security code, building details...',
    description: 'Delivery | Preferences | Note Placeholder',
  },
  deliveryPreferencesNoteHint: {
    defaultMessage: 'Add a note for the courier',
    description: 'Delivery | Preferences | Note Hint',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type DeliveryPreferencesFormNotesFieldProps = Readonly<{
  localNotes: string;
  setLocalNotes: (notes: string) => void;
}>;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  sectionLabel: {
    marginTop: theme.spacing['10'],
    marginBottom: theme.spacing['2'],
  },
  inputField: {
    height: 80,
  },
  cautionText: {
    color: theme.colors.CAUTION,
  },
});
